import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { Doughnut } from "react-chartjs-2";
import {
  Card,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const ChartPaymentTJ = () => {
  const [map, setMap] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios
      .get("https://portaldata.jaktraffic.my.id/pqs/jli/feed/viewJliDatav2", {
        params: { page: 1, pto: "TJ", pageSize: 200 },
      })
      .then((res) => {
        const rows = res.data?.data || [];
        const counter = {};

        rows.forEach((r) => {
          if (r.payment_media) {
            counter[r.payment_media] =
              (counter[r.payment_media] || 0) + 1;
          }
        });

        setMap(counter);
      })
      .finally(() => setLoading(false));
  }, []);

  const chartData = useMemo(
    () => ({
      labels: Object.keys(map),
      datasets: [
        {
          data: Object.values(map),
          backgroundColor: [
            "#42a5f5",
            "#66bb6a",
            "#ffa726",
            "#ab47bc",
          ],
        },
      ],
    }),
    [map]
  );

  return (
    <Card
      sx={{
        p: 3,
        borderRadius: 4,
        width: "100%",
        height: 420,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography variant="h6" fontWeight={700} mb={2}>
        Metode Pembayaran
      </Typography>

      <Box
        sx={{
          flex: 1,
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {loading ? (
          <CircularProgress />
        ) : (
          <Doughnut
            data={chartData}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: { position: "top" },
              },
              cutout: "60%",
            }}
          />
        )}
      </Box>
    </Card>
  );
};

export default ChartPaymentTJ;
